import 'css-chunksrc/client/pages/utilityPage/strategicAxesPage/strategicAxes/strategicAxis/styles.scss';export default {
  "strategicAxis": "_strategicAxis_ecn0j_1",
  "contextualMenu": "_contextualMenu_ecn0j_8",
  "value": "_value_ecn0j_12",
  "code": "_code_ecn0j_18",
  "name": "_name_ecn0j_22",
  "row": "_row_ecn0j_26",
  "weight": "_weight_ecn0j_35",
  "icon": "_icon_ecn0j_42"
};